import { render, staticRenderFns } from "./msisdn-viewer.vue?vue&type=template&id=3819b4de"
import script from "./msisdn-viewer.vue?vue&type=script&lang=js"
export * from "./msisdn-viewer.vue?vue&type=script&lang=js"
import style0 from "./msisdn-viewer.vue?vue&type=style&index=0&id=3819b4de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports